var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-multi" }),
        _vm._v(_vm._s(_vm.$t("Label OTA")) + " ")
      ]),
      _c(
        "div",
        { staticClass: "d-flex mt-8" },
        [
          _c(
            "div",
            { staticClass: "form-group", staticStyle: { width: "190px" } },
            [
              _c("span", { staticClass: "label-txt" }, [
                _vm._v(_vm._s(_vm.$t("OTA On/Off")))
              ]),
              _c("v-select", {
                staticClass: "form-select",
                attrs: {
                  disabled: _vm.otaSettingEditDisabled,
                  items: _vm.otaScheduleEnabledItems,
                  "item-text": "txt",
                  "item-value": "val",
                  placeholder: "On",
                  outlined: "",
                  dense: "",
                  "hide-details": ""
                },
                on: { input: _vm.handleOtaScheduleEnabledInput },
                model: {
                  value: _vm.otaScheduleEnabled,
                  callback: function($$v) {
                    _vm.otaScheduleEnabled = $$v
                  },
                  expression: "otaScheduleEnabled"
                }
              })
            ],
            1
          ),
          _c("ota-setting", {
            key: _vm.selectedStore.code,
            attrs: {
              otaSettingEditDisabled:
                _vm.otaSettingEditDisabled || !_vm.otaScheduleEnabled,
              otaSettingPopupDisabled: _vm.otaSettingPopupDisabled
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "updateStatus mt-13",
          class: !_vm.otaScheduleEnabled ? "is-off" : null
        },
        [
          _c("div", { staticClass: "total_update" }, [
            _c("div", [
              _c("p", { staticClass: "tit" }, [
                _c("strong", [_vm._v(_vm._s(_vm.$t("TOTAL LABEL")))]),
                _vm._v(_vm._s(_vm.$t("Update Status")) + " ")
              ]),
              _c("div", { staticClass: "graphBox" }, [
                _c("canvas", {
                  attrs: { id: "total", width: "220", height: "220" }
                }),
                _c("div", { staticClass: "score" }, [
                  _c("p", { staticClass: "percent" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.totalTagStatusPercentage))
                    ]),
                    _vm._v("% ")
                  ]),
                  _c("p", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.totalTagStatusFraction))
                  ])
                ])
              ])
            ])
          ]),
          !_vm.otaScheduleEnabled
            ? _c("div", { staticClass: "list_update custom-scrollbar" }, [
                _c(
                  "ul",
                  _vm._l(
                    [
                      { id: 0 },
                      { id: 1 },
                      { id: 2 },
                      { id: 3 },
                      { id: 4 },
                      { id: 5 },
                      { id: 6 }
                    ],
                    function(obj) {
                      return _c("li", { key: obj.id }, [
                        _c("p", { staticClass: "nodata" }, [
                          _vm._v(_vm._s(_vm.$t("No data available")))
                        ])
                      ])
                    }
                  ),
                  0
                )
              ])
            : _vm.tagStatusListExist
            ? _c("div", { staticClass: "list_update custom-scrollbar" }, [
                _c(
                  "ul",
                  _vm._l(_vm.tagStatusList, function(tagStatus) {
                    return _c(
                      "li",
                      {
                        directives: [
                          {
                            name: "labelOtaEnabled",
                            rawName: "v-labelOtaEnabled",
                            value: tagStatus.fwVersion,
                            expression: "tagStatus.fwVersion"
                          }
                        ],
                        key: tagStatus.tagTypeCode,
                        staticClass: "tagStatusList"
                      },
                      [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(" " + _vm._s(tagStatus.system) + " "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.getTagTypeInfo(tagStatus)) + " ")
                          ])
                        ]),
                        _c("div", { staticClass: "info_graph" }, [
                          _c("div", { staticClass: "graphBox" }, [
                            _c("div", { staticClass: "score" }, [
                              _c("p", { staticClass: "percent" }, [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getTagUpdatedPercentage(tagStatus)
                                    )
                                  )
                                ]),
                                _vm._v("% ")
                              ])
                            ])
                          ]),
                          _c("div", { staticClass: "data" }, [
                            _c("div", [
                              _c("p", [
                                _vm._v(" Quantity : "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getTagUpdatedFraction(tagStatus))
                                  )
                                ])
                              ]),
                              _c("p", [
                                _vm._v(" Firmware Version : "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      tagStatus.fwVersion
                                        ? "V" + tagStatus.fwVersion
                                        : ""
                                    )
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { staticClass: "txt-no-data" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("No data available")))])
              ])
        ]
      ),
      _c("msg-box", {
        attrs: { msgBox: _vm.msgBox },
        on: { closeMsgBox: _vm.closeMsgBox }
      }),
      _c("confirm-box", {
        attrs: { confirmBox: _vm.confirmBox },
        on: {
          confirm: _vm.confirm,
          afterConfirm: _vm.afterConfirm,
          closeConfirmBox: _vm.closeConfirmBox
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }